module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-29.9848720a.jpg";